import React from 'react'
import { Link } from 'react-router-dom'
import { all_routes } from '../../../router/all_routes'

const Instructor = () => {


    const route = all_routes;

    return (
        <>
            <section className="home-five-become">
                <div className="container">
                    <div className="row align-items-center row-gap-4">
                        <div className="col-lg-8 col-md-8" data-aos="fade-up">
                            <div className="become-content-three">
                                <h2>Become a Recruitment Partner</h2>
                                <p>
                                    Ready to scale faster, work smarter, and deliver better results? Join our global network and gain the tools, support, and control you need to grow your recruitment success.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4" data-aos="fade-up">
                            <div className="text-end">
                                <Link to={route.register} className="btn btn-white">
                                    Register Now
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>

    )
}

export default Instructor
